<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('gateway.edit')}}</span>
  </template>

  <v-form ref="form" v-model="validEditor" lazy-validation>
    <name-text-field v-model="nameText" autofocus></name-text-field>
  </v-form>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn :disabled="!canSave" :loading="saving" flat color="primary" @click="save">{{ $t('gateway.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'

export default {
  name: 'GatewayEditorDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  components: {
    'standard-dialog': Dialog,
    'name-text-field': NameTextField
  },
  data() {
    return {
      saving: false,
      validEditor: false,
      nameText: null
    }
  },
  watch: {
    hostname(val) {
      if (this.saving) {
        if (val == this.nameText) {
          this.visible = false;
        }
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    hostname() {
      return (this.userMacInfo[this.data.mac] || {}).hostname;
    },
    canSave() {
      return this.nameText != this.data.hostname;
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          cmd: 'sethostname',
          mac: this.data.mac,
          val: this.nameText
        });
      } catch (err) {
        this.$emit('toast', this.$t('gateway.permission_denied'));
        this.saving = false;
        return;
      }

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.saving = false;
        }
      });

      ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          mac: this.data.mac,
          cmd: 'reload'
        });
      } catch (err) {
        this.$emit('toast', this.$t('gateway.permission_denied'));
        return;
      }

      setTimeout(() => {
        refErr.off();
      }, 5000);
    }
  },
  mounted() {
    this.$refs.form.reset();
    this.nameText = this.data.hostname;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayEditorDialog.vue